// Added by Sejune Oh on 2020-03-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! [1] Global Event
export const GLOBAL_EVT_REFRESHDATABASE = 'cl.event.refreshdatabase'

// ! [2] General Event
export const EVT_STUDYLIST_SELECTION = 'aview.database.event.changed.studylist.selection'
export const EVT_UPDATE_CURRENT_DB = 'aview.database.event.updateCurrentDBId'
export const EVT_TASKLIST_INIT = 'aview.database.event.changed.tasklist.init'
export const EVT_TASKLIST_SELECTION = 'aview.database.event.changed.tasklist.selection'
export const EVT_UPDATE_CURRENT_TASK_STATUS = 'database.event.changed.task.status'

// ! [3] Screen Sharing Event
export const EVT_SCREEN_SHARING_ACTIVATE = 'aview.screenshare.event.changed.activation'
